var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "p-8 lg:p-12 border-b border-[#EDEDED]",
      class: _vm.index % 2 ? "md:pt-24 lg:pt-40" : "md:border-r",
    },
    [
      _c("div", { staticClass: "aspect-[1.77/1]" }, [
        _c("img", {
          staticClass: "w-full h-full object-cover",
          attrs: { src: _vm.src, alt: _vm.alt, loading: "lazy" },
        }),
      ]),
      _vm._v(" "),
      _vm.alt
        ? _c("div", { staticClass: "mt-2" }, [
            _c("h3", {
              staticClass: "paragraph",
              domProps: { textContent: _vm._s(_vm.alt) },
            }),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }